export default __webpack_public_path__ + "static/6i-dc562fc428c6b9ffc37ee3baa5f92094.woff";